import { Video } from '../types';

export const videoStartData = (data: Video): Video => ({
  name: data.name,
  url: data.url,
  provider: data.provider,
  durationTotal: data.durationTotal,
  autoplay: data.autoplay,
});

export const videoCompleteData = (data: Video): Video => ({
  name: data.name,
  url: data.url,
  provider: data.provider,
  durationTotal: data.durationTotal,
  progress: data.progress,
});

export const videoProgressData = (data: Video): Video => ({
  name: data.name,
  url: data.url,
  provider: data.provider,
  durationTotal: data.durationTotal,
  progress: data.progress,
});

export const videoErrorData = (data: Video): Video => ({
  name: data.name,
  url: data.url,
  provider: data.provider,
  durationTotal: data.durationTotal,
  error: data?.error,
});
